import { render, staticRenderFns } from "./MaintenanceUrgencyStatus.vue?vue&type=template&id=04bc6cd2&scoped=true&"
import script from "./MaintenanceUrgencyStatus.vue?vue&type=script&lang=js&"
export * from "./MaintenanceUrgencyStatus.vue?vue&type=script&lang=js&"
import style0 from "./MaintenanceUrgencyStatus.vue?vue&type=style&index=0&id=04bc6cd2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04bc6cd2",
  null
  
)

export default component.exports